var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideoIcon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-02"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31 38.75C22.8106 38.75 15.5279 42.7041 10.8913 48.8404C9.89339 50.1611 9.39444 50.8214 9.41076 51.7139C9.42337 52.4034 9.85634 53.2732 10.3989 53.699C11.1011 54.25 12.0742 54.25 14.0203 54.25H47.9796C49.9258 54.25 50.8989 54.25 51.6011 53.699C52.1436 53.2732 52.5766 52.4034 52.5892 51.7139C52.6055 50.8214 52.1066 50.1611 51.1087 48.8404C46.4721 42.7041 39.1894 38.75 31 38.75Z",
    stroke: "#45C49E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 31C37.4203 31 42.625 25.7953 42.625 19.375C42.625 12.9547 37.4203 7.75 31 7.75C24.5797 7.75 19.375 12.9547 19.375 19.375C19.375 25.7953 24.5797 31 31 31Z",
    stroke: "#45C49E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon3);
export default __webpack_public_path__ + "static/media/videoIcon3.4e278527eada10f9b439dd3da147a0a5.svg";
export { ForwardRef as ReactComponent };